import React, { useState } from "react";
import "./FaqQuestions.css";

const faqData = [

    
  {title: "What we offer?",
    content:
      "Punjabi Boli offers interactive group classes designed to improve your fluency and confidence in speaking Punjabi. These sessions promote real-time practice through conversations with peers, which can significantly accelerate language learning compared to self-study. You'll also have the opportunity to connect with individuals from diverse backgrounds who share an interest in Punjabi culture. This cultural exchange enriches your understanding of both the language and its heritage. Register for our next session to see how your child can grow linguistically and culturally.",
  },
  {
    title: "What age group is it for?",
    content:
      "Our curriculum is tailored for children aged 6 to 12 years. Punjabi Boli provides a safe, secure, and interactive group learning environment to foster engagement and effective learning.",
  },
  {
    title: "What topics are covered?",
    content:
      "Our comprehensive course focuses on Speaking, Reading, and Writing Punjabi. The curriculum is structured into four levels, with each level covering progressively advanced topics to ensure a thorough understanding of the language. For detailed information, please visit our 'Courses' page or contact us via email.",
  },
  {
    title: "Do you offer live classes or interaction with tutors?",
    content:
      "Yes, Punjabi Boli provides live, interactive classes where students can engage directly with tutors. This in-class group setting creates a unique and dynamic platform for collaborative learning.",
  },
  {
    title: "How long are the courses?",
    content:
      "Our courses are divided into four levels, with each level spanning 5 months. Students attend two classes per week, ensuring consistent progress. For additional details, feel free to reach out to us via email.",
  },
  {
    title: "Are there additional resources available?",
    content:
      "Yes, along with live classes, we provide supplementary resources such as practice worksheets, video tutorials, and cultural activities to reinforce learning. These materials are accessible to all enrolled students.",
  },
  {
    title: "What are the benefits of learning Punjabi?",
    content:
      "Learning Punjabi helps children connect with their cultural heritage, improves their communication skills, and enhances cognitive abilities. It also opens opportunities to engage with the vibrant Punjabi-speaking community worldwide.",
  },
];

const FaqQuestions = () => {
  const [lastOpen, setLastOpen] = useState(null);

  const toggleItem = (index) => {
    setLastOpen((prev) => (prev === index ? null : index));
  };

  return (
    <section id="faq">
      <div className="faq-wrapper">
        <h1>Frequently Asked Questions</h1>
        <div className="faq-container">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`item ${lastOpen === index ? "open" : ""}`}
              onClick={() => toggleItem(index)}
            >
              <div className="title">
                <span className="text">{item.title}</span>
                <span className="fas fa-chevron-down"></span>
              </div>
              <p>{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FaqQuestions;
